import { render, staticRenderFns } from "./BottomPaginator.vue?vue&type=template&id=13e0ecc2&scoped=true&"
import script from "./BottomPaginator.vue?vue&type=script&lang=js&"
export * from "./BottomPaginator.vue?vue&type=script&lang=js&"
import style0 from "./BottomPaginator.vue?vue&type=style&index=0&id=13e0ecc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0ecc2",
  null
  
)

export default component.exports